import { FlossPalette, Icon } from '@orthly/ui-primitives';
import React from 'react';

export const CheckoutRadioIcon: React.VFC<{ checked: boolean }> = ({ checked }) =>
    checked ? (
        <Icon icon={'RadioButtonCheckedIcon'} style={{ color: FlossPalette.PRIMARY_FOREGROUND }} />
    ) : (
        <Icon icon={'RadioButtonUnCheckedIcon'} style={{ color: FlossPalette.LIGHT_GRAY }} />
    );
